export interface AvailableBillGatewayAppsModel {
  code: string;
  displayName: string;
  badge?: Badge;
  hasInstructions?: boolean;
  redirectLink: {
    desktop: string;
    ios?: string;
    android?: string;
  };
  benefits: Benefit[];
}

interface Badge {
  label: string;
  icon?: string;
  tooltip?: string;
}

export enum Benefit {
  NO_COMMISSION = 'NO_COMMISSION',
  MULTI_INVOICE_PAYMENTS = 'MULTI_INVOICE_PAYMENTS',
  PAYMENT_DEFERMENT = 'PAYMENT_DEFERMENT',
  ALL_INVOICES_IN_ONE_PLACE = 'ALL_INVOICES_IN_ONE_PLACE',
  CREDIT_CARD = 'CREDIT_CARD',
  AUTOPAYMENT = 'AUTOPAYMENT'
}
